var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"mt-3"},_vm._l((_vm.categories),function(category,index){return _c('single-node',{key:index,attrs:{"node":category},on:{"edit":function($event){return _vm.$emit('edit', $event)},"remove":function($event){return _vm.$emit('remove', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }